import * as Sentry from "@sentry/vue";
import { defineNuxtPlugin } from "#app";
import { useRouter } from "#vue-router";
import { useRuntimeConfig } from "#imports";
export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();
  const {
    public: { sentry, baseUrl }
  } = useRuntimeConfig();
  if (!sentry.dsn) {
    return;
  }
  const sentryInstance = Sentry.init({
    app: nuxtApp.vueApp,
    dsn: sentry.dsn,
    environment: sentry.environment,
    ignoreErrors: [
      // Random plugins/extensions
      // Chrome extensions
      "chrome-extension://",
      // Firefox extensions
      "moz-extension://",
      // Safari extensions
      "safari-extension://",
      // Edge extensions
      "edge-extension://"
    ],
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      }),
      new Sentry.Replay()
    ],
    tracesSampleRate: 0.2,
    // Change in prod
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", baseUrl],
    replaysSessionSampleRate: 1,
    replaysOnErrorSampleRate: 1
  });
  return {
    setup() {
      return {
        provide: {
          sentry: sentryInstance
        }
      };
    }
  };
});
